export default "__VITE_ASSET__X7TdN1WB__"